import React from "react";
import PropTypes from 'prop-types';
import $ from 'jquery';
import _ from 'lodash';

import KitchenVisualizerIFrame from './kitchenVisualizerIFrame';
import StonesStore from "./../../stores/stonesStore";
import * as Misc from "./../../misc";
import ActionTypes from "./../../actionTypes";
import ProjectScope from "./../projectScope/projectScope";
import QuantityTextField from "./../quantityTextField";
import MessageBox from "./../common/messageBox/messageBox";
import MessageBoxState from "./../common/messageBox/state";
import ConfirmationScheduleView from "./confirmationScheduleView";
import NotesUploadView from "./../common/notesUpload/notesUploadView";
import LoaderView from "./../common/loaderView";
import Config from "./../../config";
import QuoteSummaryDetailFeatureItem from './quoteSummaryDetailFeatureItem';
import QuoteSummaryItem from './quoteSummaryItem';
import Disclaimer from './disclaimer';
import CustomerInfo from './customerInfo';
import FabricatorInfo from './fabricatorInfo';
import Totals from './totals';
import IntroVideo from './../common/introVideo';
import NewQuoteElement from './newQuoteElement';
import Analytics from './../../analytics';

// for these domains the scheduling won't be shown
const DomainsWithNoScheduling = {
    'nfm': 1,
    'greenacresgraniteonline': 1,
    'greenacresgranite': 1,
    'keystonegranite': 1,
    'gmsdcorponline': 1,
    'greatlakesgm': 1,
    'stoneworldtnonline': 1,
    'rocktopskc': 1,
};

const checkIfDomainHasScheduling = domain => !!DomainsWithNoScheduling[domain.toLowerCase()];

export default class SummaryView extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    let isOK = true;
    if (!ProjectScope.isBackend && !ProjectScope.quotesCount() || !ProjectScope.quotes()[0].stone) {
      isOK = false;
    }

    this.state = {
      isOK: isOK,
      grandTotal: 0,
      material: ProjectScope.quote().material,
      pendingAction: '',
      messageBoxState: MessageBoxState.state(),
      isNotesUploadVisible: ['notes', 'upload'].indexOf(Config.kvConfig.summaryViewShow.toLowerCase()) !== -1,
      notesUploadShow: Config.kvConfig.summaryViewShow || '',
      loaderVisible: false,
      currentIntroVideo: null,
      mode: Config.kvConfig.mode,
      iframeOpened: false
    };
    this.timeout = null;
  }

  componentWillMount() {
    $('.main-wrapper').scrollTop(0);
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    $(document).on(ActionTypes.SCHEDULE_COMPLETED, this.handleScheduleCompleted);
    $(document).on(ActionTypes.QUOTE_SAVED, this.handleQuoteSaved);
    $(document).on(ActionTypes.QUOTE_BEFORE_SAVE, this.handleQuoteBeforeSave);
    $(document).on('stopVideos', () => {
      this.handleClickWhenIntroVideo();
    });

    const scrollContainer = $('.review-submit-quotes-pane'),
      lastElement = scrollContainer.find('.review-submit-stone-listitemrenderer-blank:last');

    if(lastElement && lastElement.position())
    scrollContainer.scrollLeft(lastElement.position().left + lastElement.width());

    const router = this.context.router;
    const route = this.props.route;
    if (!this.state.isOK) {
      router.push('/scope');
      return;
    }

    router.setRouteLeaveHook(route, this.routeWillLeave);

    if (!ProjectScope.shownIntroVideos('reviewSubmit')) {
      ProjectScope.setShownIntroVideos('reviewSubmit', true);
      Misc.playVideo('#reviewSubmit', () => this.subscribeToDocumentClick('#reviewSubmit'));
    }

    document.setStoneFromIframeSummaryPage = (data) => {
      let stone = data.quote.stone && StonesStore.stoneById(data.quote.stone.Id);

      // console.log('ProjectScope.quote()', ProjectScope.quote());
      // console.log('data.quote', data.quote);

      if (data.quote.stone && ProjectScope.quote().stone && (data.quote.stone.Id !== ProjectScope.quote().stone.Id)) {
        ProjectScope.addQuote();
        ProjectScope.setStone(stone);
      }

      ProjectScope.setFeaturesToDisplay(data.quote.features); // show new features in iframe, but do not change in the list
      // ProjectScope.setFeatures(data.quote.features);   // we don't need it for now, but it would be needed one day

      this.forceUpdate();
    };

    document.removeLoadingMessage = () => {
      this.setState({
        iframeOpened: true
      })
    };

  }

  componentWillUnmount = () => {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
    $(document).off(ActionTypes.SCHEDULE_COMPLETED, this.handleScheduleCompleted);
    $(document).off(ActionTypes.QUOTE_SAVED, this.handleQuoteSaved);
    $(document).off(ActionTypes.QUOTE_BEFORE_SAVE, this.handleQuoteBeforeSave);
    this.handleClickWhenIntroVideo();
    $(document).off('click', this.handleClickWhenIntroVideo);
  };

  subscribeToDocumentClick = (video) => {
    this.state.currentIntroVideo = video;
    $(document)
      .off('click', this.handleClickWhenIntroVideo)
      .on('click', this.handleClickWhenIntroVideo);
  };

  handleClickWhenIntroVideo = () => {
    if (this.state.currentIntroVideo) {
      Analytics.sendClickEvent('summary-hide-video');
      Misc.hideVideo(this.state.currentIntroVideo);
      this.state.currentIntroVideo = null;
      $(document).off('click', this.handleClickWhenIntroVideo);
    }
  };

  handleQuoteBeforeSave = () => {
    this.setState({loaderVisible: true});
  };

  handleQuoteSaved = (e, data) => {
    this.setState({loaderVisible: false});

    const {error} = data.data;
    if (error) {
      let message = error;
      if (!ProjectScope.jobId) {
        message = "An error has occurred and Quote was not saved. Scheduling won't be possible. Please contact administrator";
      }

      this.setState({
        messageBoxState: {
          visible: true,
          error: true,
          message
        }
      });
      return;
    }

    if (!ProjectScope.isBackend && data.submit) {
      const fabricator = StonesStore.fabricator();
      if (checkIfDomainHasScheduling(fabricator.SubDomain)) {
        this.setState({
          messageBoxState: {
            visible: true,
            message: 'Thank you for placing your quote. A representative will contact you within 24hrs to finalize your order.',
            buttons: [
              {
                text: 'OK',
                click: () => {
                  if(document.kvConfig.kioskMode || Config.kioskStandAlone) {
                    Config.parent.resetKiosk();
                  } else if (fabricator.WebsiteUrl) {
                    let url = fabricator.WebsiteUrl;
                    if(!_.startsWith(url.toLowerCase(), 'http')) {
                      url = 'http://' + url;
                    }
                    window.location = url;
                  } else {
                    alert('Ask administrator to set the web-site URL.');
                  }
                }
              }
            ]
          }
        });

        return;
      }

      $(document).trigger(ActionTypes.SHOW_SUMMARY, {});
    }

    if (ProjectScope.isBackend) {
      this.setState({
        pendingAction: 'admin-goto-quotes',
        messageBoxState: {
          visible: true,
          message: 'The changes to your quote have been saved.',
          buttons: [
            {
              text: 'OK',
              click: () => {
                Config.parent && Config.parent.exitEditQuote && Config.parent.exitEditQuote();
              }
            }
          ]
        }
      });
    } else {
      if (this.state.pendingAction === 'schedule-completed' || this.state.pendingAction === 'schedule-completed-no-apt') {
        let message = 'Thank you for placing your quote. A representative will contact you within 24hrs to finalize your order.';
        if (this.state.pendingAction === 'schedule-completed') {
          message = 'Thank you for scheduling your appointment. A representative will contact you within 24hrs to confirm your time.';
        }
        this.setState({
          pendingAction: this.state.pendingAction,
          messageBoxState: {
            visible: true,
            message: message,
            showLoading: ProjectScope.uploadingQuote()
          }
        });
      }
    }
  };

  handleScheduleCompleted = (e, data) => {
    // 1. hide confirmation view
    $(document).trigger(ActionTypes.SHOW_SUMMARY, {visible: false});
    // 2. show messageBox with confirmation message
    this.setState({
      pendingAction: 'schedule-completed',
      messageBoxState: {
        visible: true,
        message: 'Thank you for scheduling your appointment. A representative will contact you within 24hrs to confirm your time.',
        showLoading: ProjectScope.uploadingQuote(),
        loadingText: 'Please wait while we upload your documents...'
      }
    });
  };

  handleQuoteDataChanged = () => {
    this.setState({material: ProjectScope.quote().material});
    this.forceUpdate();
  };

  handleAddQuoteClick = () => {
    Analytics.sendClickEvent('summary-add-quote');
    if (ProjectScope.quoteSubmitted) {
      return;
    }

    ProjectScope.addQuote();
    this.context.router.replace('/stones');
  };

  handleMaterialChange = (material) => {
    this.setState({material: material});
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      ProjectScope.updateMaterialQuantity(material);
    }, 300);
  };

  handleMaterialBlur = (material) => {
    var mat = parseInt(material);
    if(isNaN(mat) || mat <= 0) {
      mat = 1;
      ProjectScope.updateMaterialQuantity(mat);
    }
    Analytics.sendDataEnteredEvent('summary-material-quantity-change');
  };

  handleMessageBoxOkClick = () => {
    this.setState({messageBoxState: {visible: false}});

    switch (this.state.pendingAction) {
      case 'delete-last-quote':
        Analytics.sendClickEvent('summary-delete-last-quote-OK');
        ProjectScope.deleteQuote(ProjectScope.quote().uid);
        document.kvConfig.stepFinished = 0;
        this.context.router.replace('/scope');
        break;
      case 'schedule-completed':
      case 'schedule-completed-no-apt':
        if (this.state.pendingAction === 'schedule-completed')
          Analytics.sendClickEvent('summary-schedule-completed');
        else
          Analytics.sendClickEvent('summary-schedule-completed-no-apt');
        const fabricator = StonesStore.fabricator();
        if (fabricator.WebsiteUrl && !document.kvConfig.kioskMode) {
          let url = fabricator.WebsiteUrl;
          if(!_.startsWith(url.toLowerCase(), 'http')) {
            url = 'http://' + url;
          }
          window.location = url;
          return;
        }

        if (Config.kioskStandAlone) {
          Config.parent.$(Config.parent.document).trigger('newQuoteStarted');
        }
        ProjectScope.resetJob();
        this.context.router.push('/scope');
        break;
      case 'admin-goto-quotes':
        Analytics.sendClickEvent('summary-admin-goto-quotes');
        if (this.state.mode === 'dashboard') {
          Config.parent.$(Config.parent.document).trigger('HIDE_QUOTE_EDIT', {sender: 'quote-edit'});
        } else {
          Config.parent.window.location.href = '/job?mode=client';
        }
        break;
    }
  };

  handleMessageBoxCancelClick = () => {
    Analytics.sendClickEvent('summary-message-box-cancel');
    this.setState({messageBoxState: {visible: false}});
  };

  handleDeleteLastQuoteClick = () => {
    Analytics.sendClickEvent('summary-delete-last-quote');
    if (ProjectScope.quoteSubmitted) {
      return;
    }

    this.setState({
      pendingAction: 'delete-last-quote',
      messageBoxState: {
        visible: true,
        message: 'Are you sure you want to delete this material? This will restart your project.',
        buttons: [
          {text: 'Yes', click: this.handleMessageBoxOkClick},
          {text: "No", click: this.handleMessageBoxCancelClick}
        ]
      }
    });
  };

  handleNotesClick = (e) => {
    Analytics.sendClickEvent('summary-notes');
    Misc.ignoreDefault(e);
    this.setState({
      notesUploadShow: 'notes',
      isNotesUploadVisible: true
    });
  };

  handleUploadClick = (e) => {
    Analytics.sendClickEvent('summary-upload');
    Misc.ignoreDefault(e);
    this.setState({
      notesUploadShow: 'uploads',
      isNotesUploadVisible: true
    });
  };

  handleNotesUploadClose = () => {
    this.setState({
      isNotesUploadVisible: false
    });
  };

  handleCancelAppointment = () => {
    this.setState({
      pendingAction: 'schedule-completed-no-apt',
      messageBoxState: {
        visible: true,
        message: 'Thank you for placing your quote. A representative will contact you within 24hrs to finalize your order.',
        showLoading: ProjectScope.uploadingQuote(),
        loadingText: 'Please wait while we upload your documents...'
      }
    });
  };

  render() {
    if (!this.state.isOK) {
      return null;
    }

    return (
      <div className="review-submit-wrapper">
        <IntroVideo type="reviewSubmit"/>
        <LoaderView title="Saving Quote" text="Please wait while we save your quote."
                    visible={this.state.loaderVisible}/>
        <ConfirmationScheduleView cancel={this.handleCancelAppointment}/>
        {this.state.isNotesUploadVisible ?
          <NotesUploadView show={this.state.notesUploadShow} close={this.handleNotesUploadClose}/> : null}
        {this.state.messageBoxState.visible
          ? <MessageBox state={this.state.messageBoxState} click={this.handleMessageBoxOkClick}/>
          : null}
        <div className="review-submit-main-panel-wrapper">
          <div className="review-submit-screen-title">Review Quote &amp; Submit</div>
          <div className="review-submit-main-panel">
            {this.renderQuotes()}
            {this.renderCurrentQuoteDetails()}
          </div>
        </div>
      </div>
    );
  }

  handleEditQuoteClick = () => {
    Analytics.sendClickEvent('summary-edit-quote');
    ProjectScope.setCurrentQuote(ProjectScope.quote().uid);
    Analytics.sendPageEvent('/scope');
    this.props.router.push('/scope');
  };

  renderCurrentQuoteDetails = () => {
    const q = ProjectScope.quote();
    const fabricator = StonesStore.fabricator();
    const hidePrices = fabricator.HideCheckoutBreakdownCost;
    const items = [];

    const materialPriceClasses = "review-submit-list-total review-submit-list-controller" + (hidePrices ? " hide" : "");
    items.push((
      <div className="review-submit-qd-listitemrenderer" key='Stone'>
        <div className="review-submit-list-title review-submit-list-controller">Materials</div>
        <QuantityTextField value={this.state.material}
                           className="review-submit-list-quantity review-submit-list-controller"
                           onChange={this.handleMaterialChange} onBlur={this.handleMaterialBlur}
                           title="Material quantity"/>
        <div className={materialPriceClasses}>${q.materialPrice.toFixed(2)}</div>
      </div>
    ));

    _.forEach(q.features, function (quantity, featureID) {
      const featureCost = q.featuresCost[featureID];
      const fabricatorFeature = _.find(StonesStore.fabricatorFeatures(), f => {
        return f.featureId === +featureID;
      });

      if (!fabricatorFeature) {
        items.push(<QuoteSummaryDetailFeatureItem name={'<NoName>'} key={'feature_' + featureID}
                                                  featureCost={featureCost} quantity={quantity}
                                                  featureID={featureID}
                                                  hidePrice={hidePrices}/>);
      } else {
        const parts = fabricatorFeature.name.split(' - ');
        let name = _.tail(parts).join(' - ');
        if (name === '') {
          name = fabricatorFeature.name;
        }

        items.push(<QuoteSummaryDetailFeatureItem name={name} key={'feature_' + featureID}
                                                  featureCost={featureCost} quantity={quantity}
                                                  featureID={featureID}
                                                  hidePrice={hidePrices}/>);
      }
    });

    const ratingStyle = {
      width: (StonesStore.fabricatorRating(fabricator.Id) * 100) + '%'
    };

    let starTemplateMask = "/content/Views/QuickQuote-v3/images/StarTemplateMask.svg";

    if (Config.kioskStandAlone || location.port === '9007') {
      starTemplateMask = "./images/StarTemplateMask.svg";
    }

    return (
      <div className="review-submit-side-divider review-submit-side-divider-right">
        <div className="review-submit-right-logo">
          <div className="review-submit-right-logo-image">
            <img src={fabricator.ImageUrl} alt=""/>
          </div>
          <div className="review-submit-right-logo-rating">
            <div className="review-submit-fabricator-rating">
              <img src={starTemplateMask}
                   className="review-submit-fabricator-rating-depth"/>
              <div className="review-submit-fabricator-rating-bar" style={ratingStyle}/>
            </div>
            {/*<span className="review-submit-right-logo-all-reviews">See All Reviews</span>*/}
          </div>
        </div>
        <div className="review-submit-scroll-pane" key="right-side">
          {items}
          <Disclaimer/>
          <div className="review-submit-info-wrapper">
            <CustomerInfo/>
            <FabricatorInfo/>
          </div>
        </div>
        <Totals handleEditQuoteClick={this.handleEditQuoteClick}/>
      </div>
    );
  };

  renderQuotes = () => {
    const quotes = ProjectScope.quotes();
    const quotesElements = quotes.map(q => {
      return (<QuoteSummaryItem quote={q} key={q.uid} deleteLastQuoteClick={this.handleDeleteLastQuoteClick}
                                router={this.context.router}/>);
    });

    const quotesElementsIframe = quotes.map(q => {
      const isSelected = q.uid === ProjectScope.quote().uid;
      return (<KitchenVisualizerIFrame quote={q} key={q.uid} iframeOpened={this.state.iframeOpened}
                                       iframeRender={true} isSelected={isSelected}
                                       openKitchenVisualizerIframe={this.props.openKitchenVisualizerIframe}/>);
    });

    return (
      <div className="review-submit-side-divider review-submit-side-divider-left">
        <div className="review-submit-customer-info-buttons">
          {ProjectScope.isInKioskMode
            ? null
            :
            <div className="review-submit-customer-info-buttons-uploads" onClick={this.handleUploadClick}/>}
          <div className="review-submit-customer-info-buttons-notes" onClick={this.handleNotesClick}/>
        </div>
        <div className="review-submit-iframe-pane">
          {quotesElementsIframe}
        </div>
        <div className="review-submit-quotes-pane">
          {quotesElements}
          <NewQuoteElement handleAddQuoteClick={this.handleAddQuoteClick}/>
          {((quotes.length <= 1) && ($(window).width() > 1280)) ?
            <NewQuoteElement handleAddQuoteClick={this.handleAddQuoteClick}/> : null}
          {((quotes.length <= 2) && ($(window).width() > 1280)) ?
            <NewQuoteElement handleAddQuoteClick={this.handleAddQuoteClick}/> : null}
          {((quotes.length <= 3) && ($(window).width() > 1800)) ?
            <NewQuoteElement handleAddQuoteClick={this.handleAddQuoteClick}/> : null}
        </div>
        <Disclaimer/>
        <div className="review-submit-info-wrapper">
          <CustomerInfo/>
          <FabricatorInfo/>
        </div>
      </div>
    );
  };
};




// WEBPACK FOOTER //
// ./src/components/projectSummary/summaryView.js